export enum CareTaskNotDoneReason {
  /* Senior refused to perform the task. */
  SeniorRefusal = 'senior-refusal',

  /* Absence of the senior. */
  seniorAbsence = 'senior-absence',

  /* Lack of the material needed to perform the task. */
  LackOfMaterial = 'lack-of-material',

  /* Senior was not feeling well. */
  SeniorWasNotFeelingWell = 'senior-was-not-feeling-well',

  /* Other reason. */
  Other = 'other',
}
